module.exports = __webpack_public_path__ + "15b376d2.svg";